import React, { ReactElement } from 'react';
import {
  Button, Td, Th, Tr,
} from 'idsk-react-components';
import LegislativnyMaterialCreateUpdate from '../../../../model/legislativnyMaterial/LegislativnyMaterialCreateUpdate';
import LegMaterialCreateStepEnum from '../../../../model/legislativnyMaterial/LegMaterialCreateStepEnum';
import './checkDataTable.scss';
import FilledTableBasicData2 from './FilledTableBasicData2';
import {
  additionalAttributeKodList,
  arrayIncludesInObj,
  basicAttributeKodList, onlyHlavnyPredpisKodList,
} from '../../../../function/legMaterialFunctions';

interface Props {
  legislativnyMaterial: LegislativnyMaterialCreateUpdate;
  onChangeStep: (nextStep: LegMaterialCreateStepEnum) => Promise<void>;
  isUpdate?: boolean;
}

const FilledTableRelatedData3 = ({
  legislativnyMaterial,
  onChangeStep,
  isUpdate = false,
}: Props): ReactElement => (
  <>
    <FilledTableBasicData2
      legislativnyMaterial={legislativnyMaterial}
      onChangeStep={onChangeStep}
    />
    {!(arrayIncludesInObj(basicAttributeKodList, legislativnyMaterial.typ.kod)) && (
      <>
        <Tr>
          <Th>Súvisiace procesy <span className="idsk-hint">(nepovinný údaj)</span></Th>
          <Td>
            {legislativnyMaterial.suvisiaceProcesy.length === 1
              ? legislativnyMaterial.suvisiaceProcesy[0].cisloLpNazov : (
                <ul>
                  {legislativnyMaterial.suvisiaceProcesy.map(proces => (
                    <li key={proces.cisloLp}>{proces.cisloLpNazov}</li>
                  ))}
                </ul>
              )}
          </Td>
          <Td>
            <Button
              size="small"
              buttonStyle="link"
              onClick={() => {
                onChangeStep(LegMaterialCreateStepEnum.RELATED_DATA_3);
              }}
            >
              Zmeniť
            </Button>
          </Td>
        </Tr>
      </>
    )}
    {(arrayIncludesInObj(additionalAttributeKodList, legislativnyMaterial.typ.kod)) && (
      <>
        <Tr>
          <Th>Hlavný novelizovaný predpis <span className="idsk-hint">(nepovinný údaj)</span></Th>
          <Td>{legislativnyMaterial?.hlavnyNovelizovanyPredpis?.popis}</Td>
          <Td>
            {!isUpdate && (
              <Button
                size="small"
                buttonStyle="link"
                onClick={() => {
                  onChangeStep(LegMaterialCreateStepEnum.RELATED_DATA_3);
                }}
              >
                Zmeniť
              </Button>
            )}
          </Td>
        </Tr>
        {!(arrayIncludesInObj(onlyHlavnyPredpisKodList, legislativnyMaterial.typ.kod)) && (
          <Tr>
            <Th>Ďalšie novelizované predpisy <span className="idsk-hint">(nepovinný údaj)</span></Th>
            <Td>
              {legislativnyMaterial.novelizovanePredpisy.length === 1
                ? legislativnyMaterial.novelizovanePredpisy[0].popis : (
                  <ul>
                    {legislativnyMaterial.novelizovanePredpisy.map(proces => (
                      <li key={proces.iri}>
                        {proces.popis}
                      </li>
                    ))}
                  </ul>
                )}
            </Td>
            <Td>
              {!isUpdate && (
              <Button
                size="small"
                buttonStyle="link"
                onClick={() => {
                  onChangeStep(LegMaterialCreateStepEnum.RELATED_DATA_3);
                }}
              >
                Zmeniť
              </Button>
              )}
            </Td>
          </Tr>
        )}
      </>
    )}
  </>
);

export default FilledTableRelatedData3;
